import { render } from "./modalCoachBookCall.vue?vue&type=template&id=5bf53593&scoped=true"
import script from "./modalCoachBookCall.vue?vue&type=script&lang=js"
export * from "./modalCoachBookCall.vue?vue&type=script&lang=js"

import "./modalCoachBookCall.vue?vue&type=style&index=0&id=5bf53593&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf53593"]])

export default __exports__